/**
 * Filesystem Types für Version 2.0 Projekte
 * 
 * WICHTIG: Diese Types gelten NUR für Projekte mit version: "2.0"
 * Alte Projekte (version < 2.0) nutzen weiterhin die alte Logik!
 */

// Datei-Definition in project.json (filesystem.files[])
export interface FileDefinition {
  path: string;           // Relativer Pfad im VFS (z.B. "code.html")
  name: string;           // Anzeigename im Tab (z.B. "HTML")
  language: string;       // Monaco Sprache (z.B. "html", "javascript", "css")
  replaceKey?: string;    // Für Template-Ersetzung (z.B. "<!--{html}-->")
  active?: boolean;       // Ist dieser Tab aktiv?
  readOnly?: boolean;     // Nur lesen, nicht bearbeiten
}

// Filesystem-Konfiguration in project.json
export interface FilesystemConfig {
  root?: string;          // Interner VFS-Pfad (optional, Default: /projects/{projectId})
  files: FileDefinition[];
}

// Projekt-Format Version 2.0
export interface ProjectJsonV2 {
  version: "2.0";
  project: string;
  language: string;
  hint?: string;
  template?: string;
  init?: string;
  initKey?: string;
  filesystem: FilesystemConfig;
  eval?: {
    type: string;
    [key: string]: any;
  };
  [key: string]: any;     // Weitere Properties erlauben
}

// Alte Projekt-Struktur (Version < 2.0 oder ohne Version)
export interface ProjectJsonLegacy {
  version?: string;       // Fehlt oder < "2.0"
  project: string;
  language: string;
  tabs?: Array<{
    name: string;
    language: string;
    content?: string;
    replaceKey?: string;
    [key: string]: any;
  }>;
  [key: string]: any;
}

// Union Type für alle Projekt-Formate
export type ProjectJson = ProjectJsonV2 | ProjectJsonLegacy;

// Datei-Eintrag im VFS (für UI)
export interface VFSEntry {
  name: string;
  path: string;
  type: 'file' | 'directory';
  size?: number;
  modifiedAt?: Date;
}

// VFS Event für Change-Listener
export interface VFSChangeEvent {
  type: 'create' | 'update' | 'delete' | 'rename';
  path: string;
  newPath?: string;       // Bei rename
}

// VFS Change Listener
export type VFSChangeListener = (event: VFSChangeEvent) => void;

// Prüft ob ein Projekt Version 2.0 ist
export function isProjectV2(project: ProjectJson): project is ProjectJsonV2 {
  return project?.version === "2.0" && 'filesystem' in project;
}

// Prüft ob ein Projekt die alte Struktur hat
export function isProjectLegacy(project: ProjectJson): project is ProjectJsonLegacy {
  return !isProjectV2(project);
}

